"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getMasterExcavator = exports._deleteExcavator = exports._editExcavator = exports._createExcavator = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _createExcavator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/excavator';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._createExcavator = _createExcavator;
const _editExcavator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/excavator/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.put(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: 0,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._editExcavator = _editExcavator;
const _deleteExcavator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/excavator/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.delete(url, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._deleteExcavator = _deleteExcavator;
const _getMasterExcavator = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/master-data/excavator';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getMasterExcavator = _getMasterExcavator;
